import api from '@/services/api'
import { getOptionsString } from '@/services/api/helpers'

const addTeamUser = (teamId, userId) => {
  return api.post(`/teams/${teamId}/users`, {user: userId}).then(async ({data}) => {
    return data
  })
}

const createTeam = (path, payload) => {
  return api.post(path, payload).then(async ({data}) => {
    return data
  })
}

const createNetwork = (payload) => {
  return api.post('/networks', payload).then(async ({data}) => {
    return data
  })
}

const deleteNetwork = (path) => {
  return api.delete(path).then(async ({data}) => {
    return data
  })
}

const deleteOrgUser = (path) => {
  return api.delete(path).then(async ({data}) => {
    return data
  })
}

const deleteTeamUser = (teamId, userId) => {
  return api.delete(`/teams/${teamId}/users/${userId}`).then(async ({data}) => {
    return data
  })
}

const getNetwork = (networkId) => {
  return api.get(`/networks/${networkId}`).then(async ({data}) => {
    return data
  })
}

const getOrgInvites = (path, options) => {
  let optionsString = getOptionsString(options)

  return api.get(`${path}?${optionsString}`).then(async ({data}) => {
    return data
  })
}

const getOrgNetworks = (path, options) => {
  let optionsString = getOptionsString(options)

  return api.get(`${path}?${optionsString}`).then(async ({data}) => {
    return data
  })
}

const getOrgUsers = (path, options) => {
  let optionsString = getOptionsString(options)

  return api.get(`${path}?${optionsString}`).then(async ({data}) => {
    return data
  })
}

const getOrgUser = (userId, accountId) => {
  return api.get(`/accounts/${accountId}/user_permissions/${userId}`).then(async ({data}) => {
    return data
  })
}

const getPodcastsInviteForm = () => {
  return api.get('/podcasts/invitations').then(async ({data}) => {
    return data.invite
  })
}

const getOrgUserNetworks = (userId, options) => {
  const optionsString = getOptionsString(options)

  return api.get(`/users/${userId}/networks?${optionsString}&default=false`).then(async ({data}) => data)
}

const getOrgUserShows = (userId, options) => {
  const optionsString = getOptionsString(options)

  return api.get(`/users/${userId}/podcasts?${optionsString}`).then(async ({data}) => data)
}

const getTeams = (accountId) => {
  return api.get(`/teams?account_id=${accountId}`).then(async ({data}) => {
    return data
  })
}

const reassignTeam = (teamId, userId, payload) => {
  return api.post(`/teams/${teamId}/users/${userId}/reassign`, payload).then(async ({data}) => data)
}

const sendPodcastsInvite = (path, payload) => {
  return api.post(path, payload).then(async ({data}) => {
    return data
  })
}

const updateTeam = (path, payload) => {
  return api.post(path, payload).then(async ({data}) => {
    return data
  })
}

const updateNetwork = (path, payload) => {
  return api.post(path, payload).then(async ({data}) => {
    return data
  })
}

const updateUserRole = (path, payload) => {
  return api.post(path, payload).then(async ({data}) => {
    return data
  })
}

export default {
  addTeamUser,
  createTeam,
  createNetwork,
  deleteNetwork,
  deleteOrgUser,
  deleteTeamUser,
  getNetwork,
  getOrgInvites,
  getOrgNetworks,
  getOrgUserNetworks,
  getOrgUserShows,
  getOrgUsers,
  getOrgUser,
  getPodcastsInviteForm,
  getTeams,
  reassignTeam,
  sendPodcastsInvite,
  updateTeam,
  updateNetwork,
  updateUserRole
}
